/*
* Image Magnify function on PDP
*
**/

custom.pdpMagnifier = (() => {

  const className = 'js-pdp-magnifier';
  const fullscreenClassName = 'js-pdp-magnifier-fullscreen';
  const imagesContainerSelector = '.product-detail__images';
  // Must match @screen md-up, where the fullscreen zoom CSS applies
  const zoomMediaQuery = '(min-width: 768px)';
  // Fullscreen grows .product-detail__images from 50% to 83.33333% (product-detail.scss)
  const zoomFactor = 5 / 3;
  const baseSizesAttr = 'data-sizes-base';

  function setZoomSizes() {
    if(!window.matchMedia(zoomMediaQuery).matches) return;
    $(`${imagesContainerSelector} picture`).each(function() {
      const $img = $(this).find('img');
      if(!$img.length) return;
      const zoomedWidth = Math.ceil($img.width() * zoomFactor);
      if(!zoomedWidth) return;
      $(this).find('source, img').each(function() {
        ['sizes', 'data-sizes'].forEach((attr) => {
          if(this.getAttribute(attr) === null) return;
          if(this.getAttribute(baseSizesAttr) === null) {
            this.setAttribute(baseSizesAttr, this.getAttribute(attr));
          }
          this.setAttribute(attr, `${zoomedWidth}px`);
        });
      });
    });
  }

  function restoreZoomSizes() {
    $(`${imagesContainerSelector} [${baseSizesAttr}]`).each(function() {
      const baseSizes = this.getAttribute(baseSizesAttr);
      ['sizes', 'data-sizes'].forEach((attr) => {
        if(this.getAttribute(attr) !== null) this.setAttribute(attr, baseSizes);
      });
    });
  }

  function openMagnifier(event=null) {
    setZoomSizes();
    $('body').addClass(fullscreenClassName);
    if(event.currentTarget && $(event.currentTarget).length) {
      const $targetImage = $(event.currentTarget);
      if($targetImage.hasClass('is-image')) {
        setTimeout(() => {
          $targetImage[0].scrollIntoView({behavior: "smooth", block: "start", container: "nearest"});
        }, 250);
      }
    }
    return true;
  }

  function closeMagnifier(event=null) {
    if(!$(event.currentTarget).hasClass(className) && !$('body').hasClass(fullscreenClassName)) return;
    restoreZoomSizes();
    if(event.currentTarget && $(event.currentTarget).length) {
      const $targetImage = $(event.currentTarget);
      if($targetImage.hasClass('is-image')) {
        setTimeout(() => {
          $targetImage[0].scrollIntoView({behavior: "smooth", block: "center", container: "nearest"});
        }, 250);
      }
    } 
    return $('body').removeClass(fullscreenClassName);
  }

  function toggleMagnifier(event=null) {
    event.stopPropagation();
    return ($('body').hasClass(fullscreenClassName))? closeMagnifier(event) : openMagnifier(event);
  }

  function closeMagnifierOutside(event=null) {
    if (!event.target.classList.contains(className) && !event.target.hasAttribute("data-product-image-id")) {
      if($('body').hasClass(fullscreenClassName)) {
        restoreZoomSizes();
        $('body').removeClass(fullscreenClassName);
      }
    }
  }

  let init = () => {
    if($(`.${className}`)) {
      $(`body`).on('click', closeMagnifierOutside);
      $(`.${className}`).on('click', toggleMagnifier);
    }
  }

  return {
    init
  }
})();

custom.pdpMagnifier.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/pdp-magnifier.js